export default {
  data() {
    return {
      partnerId: 'orange',
      isPartnerLoginEnabled: process.env.VUE_APP_PARTNER_LOGIN_ENABLED === 'true'
    };
  },
  computed: {
    getUserToken() {
      return this.$store.getters['account/getToken'];
    },
    isOrangeLogin() {
      const { params } = this.$route;
      return params.partner === this.partnerId && params.action === 'login';
    },
    isOrangeMoroccoLogin () {
      const { query } = this.$route
      if (query['subscriptionId'] || query['operationId']) {
        this.$store.dispatch('account/setPartnerIntergationInfo', {
          subscriptionId: this.$route.query?.subscriptionId, 
          operationId: this.$route.query?.operationId
        })
      }
      return query['subscriptionId'] || query['operationId']
    },
    canUseOrangeLogin() {
      return this.isOrangeLogin
        && this.getUserToken === false
        && this.isPartnerLoginEnabled;
    },
    canUseOrangeMoroccoLogin() {
      return this.isOrangeMoroccoLogin
        && this.isPartnerLoginEnabled;
    },
    haveOMPertnerLoginInfo () {
      return (this.$store.getters['account/getOperationId']
        || this.$store.getters['account/getSubscriptionId'])
    },
  },
  methods: {
    initOrangeLogin() {
      this.$store.dispatch('account/getOrangeSubscriberData');
    },
    initOrangeMoroccoLogin() {
      this.$store.dispatch('account/getOrangeMoroccoSubscriberData');
    }
  },
  created() {
    if (this.canUseOrangeLogin) {
      this.initOrangeLogin();
    } else if (this.canUseOrangeMoroccoLogin || this.haveOMPertnerLoginInfo) {
      this.initOrangeMoroccoLogin()
    }
  }
};